import React from "react";

import { ControlType, InputType } from "../../../../../../models";
import {
  DateSelector,
  DropdownSelect,
  InputText,
  Money,
  MultiFieldSelector,
  MultiLevelSelectorWithLogo,
  MultiSelector,
  PhotoUploader,
  SwitchButton,
  YearSelector,
  SingleColorSelector,
  SingleSelector,
  TimeInput
} from "../../../../../../components/FormControls";
import { MultiFieldSelectorCheckBox } from "../../../../../../components/FormControls/MultiFieldSelectorCheckBox";
import { HorsePower } from "../../../../../../components/FormControls/HorsePowerInput";
import { Tyres } from "../../../../../../components/FormControls/Tyres";
import { InputTextList } from "../../../../../../components/FormControls/InputTextList";
import { LocationMultiSelect } from "../../../../../../components/FormControls/LocationMultiSelect";
import SuggestedTitle from "../../../../../../components/FormControls/SuggestedTitle";
import SuggestedAiTitle from "../../../../../../components/FormControls/SuggestedAiTitle";
import SuggestedAiDescription from "../../../../../../components/FormControls/SuggestedAiDescription";
import ContactNumbers from "../../../../../../components/FormControls/ContactNumbers/ContactNumbers";
import { RegistrationSelect } from "../../../../../../components/FormControls/RegistrationSelect";
import { LocationSelector } from "../../../../LocationSelector/LocationSelector";

const ControlComponent = props => {
  const { type, dataSource } = props.data;
  switch (type) {
    case ControlType.multiLevel:
      return dataSource === "location" ? (
        <LocationSelector {...props} />
      ) : (
        <MultiLevelSelectorWithLogo
          {...props}
          {...props.data}
          onError={props.onError}
          showPopular
        />
      )

    case ControlType.multiFieldSelectorCb:
      return <MultiFieldSelectorCheckBox {...props} {...props.data} />;

    case ControlType.multiFieldSelector:
      return <MultiFieldSelector {...props} {...props.data} />;

    case ControlType.dropdown:
      return props.data.isRequired ? (
        <DropdownSelect {...props} {...props.data} />
      ) : (
        <DropdownSelect
          {...props}
          {...props.data}
          hasAnyValue
          anyTitle={"Odaberite"}
        />
      );

    case ControlType.datePicker:
      return (
        <DateSelector
          {...props}
          {...props.data}
          controlType={InputType.date}
          middleValue
        />
      );

    case ControlType.monthYearPicker:
      return (
        <RegistrationSelect
          {...props}
          {...props.data}
        />
      );


    case ControlType.yearPicker:
      return <YearSelector {...props} {...props.data} />;

    case ControlType.suggestedTitle: // TODO: Davor - remove this when all categories are migrated to AI
      return <SuggestedTitle {...props} {...props.data} />;

    case ControlType.suggestedAITitle:
      return <SuggestedAiTitle {...props} {...props.data} />;

    case ControlType.suggestedAIDescription:
      return <SuggestedAiDescription{...props} {...props.data} />;

    case ControlType.inputText:
      return <InputText {...props} {...props.data} />;

    case ControlType.inputTextList:
      return <InputTextList {...props} {...props.data} />;

    case ControlType.money:
      return <Money {...props} {...props.data} />;

    case ControlType.switch:
      return <SwitchButton {...props} {...props.data} />;

    case ControlType.photoUploader:
      return <PhotoUploader {...props} {...props.data} />;

    case ControlType.multiSelector:
      return <MultiSelector {...props} {...props.data} />;

    case ControlType.singleColorSelector:
      return <SingleColorSelector {...props} {...props.data} />;

    case ControlType.horsePower:
      return <HorsePower {...props} {...props.data} />;

    case ControlType.radioSelector:
      return <SingleSelector {...props} {...props.data} />;


    case ControlType.tyres:
      return <Tyres {...props} {...props.data} />;

    case ControlType.phones:
      return <ContactNumbers {...props} {...props.data} />

    case ControlType.timeInput:
      return <TimeInput {...props} {...props.data} />

    case ControlType.locationMultiSelect:
      return <LocationMultiSelect {...props} {...props.data} />;

    default:
      return null;
  }
};

export default ControlComponent;



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/GroupPage/GroupControls/Control/ControlComponent/index.tsx